import React, { useEffect, useState } from "react";
import Axios from '../../../utils/api/axiosConf';
import { url } from '../../../utils/api/api';
import { RedNotif, GreenNotif } from '../../../utils/utils';
import { Row, Col, Modal } from "antd";
import { color } from "../../../utils/themes/color";
import TABALE from "../../../components/table/table";
import INPUT from "../../../components/input/input";
import TEXTROW from "../../../components/textRow";
import BUTTON from '../../../components/buttons/button';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';



export default function Identification() {

    const [loading, setLoading] = useState({ 1: false, 2: false })
    const [data, setData] = useState([]);
    const [updater, setUpdater] = useState(1);
    const [item, setItem] = useState({ title: "", price: "", days: "" })
    const [deletedItem, setDeletedItem] = useState();
    const [showModal, setShowModal] = useState(false);



    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}settings/setting-list`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setLoading({ ...loading, 1: false })
                    setData(response.data)

                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [updater])

    const columns = [
        {
            title: 'نام تخفیف',
            dataIndex: 'title',
            render: (e) =>
                <div style={{ lineBreak: "anywhere" }}>
                    <p>{e}</p>
                </div>
        },
        {
            title: 'مقدار',
            dataIndex: 'value',
            render: (e) =>
                <div style={{ lineBreak: "anywhere" }}>
                    <p>{e}</p>
                </div>
        },
        {
            title: 'واحد',
            dataIndex: 'valueType',
            render: (e) =>
                <div style={{ lineBreak: "anywhere" }}>
                    <p>{e}</p>
                </div>
        },
        {
            title: 'ویرایش',
            render: (e) => {
                return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div
                        style={{
                            background: color.primary, borderRadius: "5px", paddingTop: "4px",
                            width: "70px", display: 'flex', justifyContent: 'center', alignItems: 'center',
                            height: '25px'
                        }}>
                        <div style={{ cursor: "pointer" }}
                            onClick={() => setItem({ title: e.title, value: e.value, key: e.key })}
                        >  <EditOutlined />  </div>
                        {/* &nbsp;&nbsp;
                        <div style={{ cursor: "pointer" }}
                            onClick={() => {
                                setDeletedItem(e)
                                setShowModal(true)
                            }}
                        >  <DeleteOutlined />  </div> */}

                    </div>
                </div >
            }


        },

    ];

    // const deleteItem = () => {
    //     Axios.delete(`${url}settings/delete/${deletedItem._id}`)
    //         .then(async (response) => {
    //             if (response.status === 200 || response.status === 201) {
    //                 setUpdater(updater + 1)
    //                 GreenNotif(response.message);
    //                 setItem({ title: "", description: "" })
    //                 setShowModal(false);
    //             } else {
    //                 RedNotif(response.message);
    //             }
    //         })
    //         .catch((error) => {
    //             RedNotif("سرور قادر به پاسخ گویی نمی باشد")
    //             console.log("error", error)
    //         });
    // }


    const updateItem = () => {
        if (item.value != null && item.value != "" ) {
            setLoading({ ...loading, 2: true })
            var x = {
                value: item.value,
                settingKey: item.key
            }
            Axios.patch(`${url}settings/update-setting`, x)
                .then(async (response) => {
                    if (response.status === 200 || response.status === 201) {
                        GreenNotif(response.message)
                        setLoading({ ...loading, 2: false })
                        setUpdater(updater + 1)
                        setItem({ key: "", value: "", title: "" })
                    } else {
                        RedNotif(response.message);
                        setLoading({ ...loading, 2: false })

                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading({ ...loading, 2: false })

                });
        } else {
            RedNotif("هر سه فیلد اجباری می باشد")
        }
    }


    return (
        <>
            {/* <Modal open={showModal} footer={false} onCancel={() => setShowModal(false)}>
                <p>آیا از حذف این پکیج مطمعن هستید؟</p>
                <Row gutter={20} style={{ marginTop: "25px" }}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <BUTTON text={"خیر"} type={"cancel"} event={() => setShowModal(false)} />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <BUTTON text={"بله"} type={"submit"} event={() => deleteItem()} />

                    </Col>
                </Row>
            </Modal> */}
            <Row >
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <div style={{ background: color.onPrimary, width: '100%', height: "40px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <p style={{ color: "white", fontSize: "18px" }}> لیست کد ها</p>
                    </div>
                    <TABALE
                        data={data}
                        columns={columns}
                        loading={loading[1]}
                    />
                </Col>
                {
                    item.key != null && item.key != undefined && item.key != ""
                        ?
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} style={{ padding: "0 50px" }} value={item.title}>
                            <p> نام تخفیف: </p>
                            <br />
                            <INPUT
                                
                                value={item.title} />
                            <br /><br />
                            <p>مقدار: *</p>
                            <br />
                            <INPUT
                                i={(e) => setItem({ ...item, value: e })}
                                value={item.price} />
                            <br /><br />
                            <BUTTON
                                text={"بروزرسانی تخفیف"}
                                loading={loading[2]}
                                event={() => updateItem()}
                            />

                        </Col>
                         : <p></p>
                    }
            </Row>
        </>
    )
}